import i18n from 'i18n';
import { IDealSourceDataFlags } from 'modules/core/types/dealSource';

export const DEAL_SOURCE_DATA_FLAGS_INITIAL: IDealSourceDataFlags = {
  isLoading: false,
  message: '',
  isInvalid: undefined,
  isReceived: false,
  isGetInvalid: false,
  isUpdated: false,
};

export function computeGetFulfilledFlags(currentFlags: IDealSourceDataFlags): IDealSourceDataFlags {
  return { ...currentFlags, isReceived: true, isGetInvalid: false };
}

export function computeGetPendingFlags(currentFlags: IDealSourceDataFlags): IDealSourceDataFlags {
  return { ...currentFlags, isReceived: false, isGetInvalid: false };
}

export function computeGetRejectedFlags(currentFlags: IDealSourceDataFlags): IDealSourceDataFlags {
  return { ...currentFlags, isReceived: true, isGetInvalid: true };
}

export function computePostFulfilledFlags(currentFlags: IDealSourceDataFlags): IDealSourceDataFlags {
  return {
    ...currentFlags,
    isLoading: false,
    isInvalid: false,
    message: i18n.t('components.loanVariablesModal.successMessages.submitDeal'),
  };
}

export function computePostPendingFlags(currentFlags: IDealSourceDataFlags): IDealSourceDataFlags {
  return {
    ...currentFlags,
    isLoading: true,
    isInvalid: false,
    message: '',
  };
}

export function computePostRejectedFlags(currentFlags: IDealSourceDataFlags): IDealSourceDataFlags {
  return {
    ...currentFlags,
    isLoading: false,
    isInvalid: true,
    message: i18n.t('components.loanVariablesModal.errorMessages.submitDeal'),
  };
}
